import gql from 'graphql-tag';
import history from '../../history';
import showToaster from '../../helpers/showToaster';
import { setLoaderStart, setLoaderComplete } from '../../actions/loader/loader';

export function editDriver(values) {

  return async (dispatch, getState, { client }) => {

    const mutation = gql`
        
        mutation updateDriver(
            $id: ID,
            $firstName: String,
            $lastName: String,
            $email: String,
            $password: String,
            $phoneDialCode: String
            $phoneNumber: String,
            $userStatus: String,
            $isBan: Int,
            $phoneCountryCode: String
            $gender: String
            $preferredCurrency: String
            ) {
            updateDriver(
              id: $id
              firstName: $firstName
              lastName: $lastName
              email:$email
              password: $password
              phoneDialCode: $phoneDialCode
              phoneNumber: $phoneNumber
              userStatus: $userStatus
              isBan: $isBan
              phoneCountryCode: $phoneCountryCode
              gender: $gender
              preferredCurrency: $preferredCurrency
            )
            {
              status
              errorMessage
            }
          }
        `;
    const query = gql`
        query getAllDriver($currentPage: Int){
            getAllDrivers(currentPage: $currentPage){
             count
              userData{
                email
                  phoneNumber
                    createdAt
                    profile{
                      profileId
                      firstName
                      lastName
                      country
                      gender
                    }
              }
            }
          }
        `;

    dispatch(setLoaderStart('EditDriver'));

    const { data } = await client.mutate({
      mutation,
      variables: {
        id: values?.id,
        firstName: values?.firstName,
        lastName: values?.lastName,
        email: values?.email,
        password: values?.password,
        phoneDialCode: values?.phoneDialCode,
        phoneNumber: values?.phoneNumber,
        userStatus: values?.userStatus,
        isBan: values?.isBan,
        phoneCountryCode: values?.phoneCountryCode,
        gender: values?.gender,
        preferredCurrency: values?.preferredCurrency
      },
      refetchQueries: [{
        query,
        variables: {
          currentPage: 1
        }
      }]
    });

    dispatch(setLoaderComplete('EditDriver'));

    if (data?.updateDriver?.status === 200) {
      history.push('/siteadmin/drivers')
      showToaster({ messageId: 'updateDriver', toasterType: 'success' })
    } else {
      showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: data?.updateDriver?.errorMessage })
    }
  }
}